import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=0cba58f2"
import script from "./upload.vue?vue&type=script&lang=js"
export * from "./upload.vue?vue&type=script&lang=js"
import style0 from "./upload.vue?vue&type=style&index=0&id=0cba58f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../amenities/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports